// removed by extract-text-webpack-plugin
module.exports = {"capabilities":"_34YN","table":"H2eg"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersAvailableTable/NumbersAvailableTable.scss
// module id = pd7X
// module chunks = 0